import React from 'react';
import { Pie } from '@ant-design/plots';

const PieChart = ({ pieChartData }) => {

  // Configure the chart
  const config = {
    data: Array.isArray(pieChartData) ? pieChartData : [],
    angleField: 'value',
    colorField: 'type',
    radius: 0.8,
    label: {
      text: (d) => `${d.type}: ${d.value}`,
      position: 'outside',
    },
    legend: {
      color: {
        title: false,
        position: 'right',
        rowPadding: 5,
      },
    },
    // Keep innerRadius unset for a full pie chart (not donut)
  };

  return <Pie {...config} />;
};

export default PieChart;